module.exports = __webpack_public_path__ + "img/tools_pic1.3cfafe77.jpg";